<template>
  <div>
    <div class="text-5 font-weight-medium">Staking Ecosystem</div>
    <div class="d-flex align-center mt-2">
      <img :src="selectedEcosystem.logo" alt="" height="40" width="40" />
      <div class="ml-4 heading-5 font-weight-medium">
        {{ selectedEcosystem.name }}
      </div>
    </div>
  </div>
</template>

<script>
import ECOSYSTEMS from "@/common/config/ecosystems";
export default {
  props: ["ecosystem"],
  computed: {
    selectedEcosystem() {
      return ECOSYSTEMS.find(
        item => item.name.toLowerCase() === this.ecosystem.toLowerCase()
      );
    },
  },
  data: () => ({
    ecosystems: ECOSYSTEMS,
  }),
};
</script>
